/**
 * Simulates network latency for the mock data layer so loading states,
 * skeletons, and suspense boundaries behave like they will against a real API.
 * Every function here has the same async shape a real fetch() call would —
 * swapping to a real backend later means changing the body, not the callers.
 */
export function withLatency<T>(value: T, ms = 260): Promise<T> {
  return new Promise((resolve) => setTimeout(() => resolve(value), ms));
}
